import {Card, Col, List, Radio, Row, Button, Input, Form, notification} from 'antd';
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Request from '../../request';
import common from '../common.less'
import {TableComp} from 'sz-react-utils'
import _ from 'lodash'
import Autosuggest from 'react-autosuggest';
import followUpsIcon from '../../assets/icons/registration/followUpsIcon.png';
import styles from './styles.less';
import ActiveIcon from '../../assets/icons/ActiveIcon.png';
import DidntPickCallIcon from '../../assets/icons/DidntPickCallIcon.png';
import BusyIcon from '../../assets/icons/BusyIcon.png';
import coldIcon from '../../assets/icons/coldIcon.png';
import NotInterestedIcon from '../../assets/icons/NotInterestedIcon.png';
import OutOfTownIcon from '../../assets/icons/OutOfTownIcon.png';
import {getUrlPushWrapper} from "../../routes";

import ListDrawer from './list';

import {
    FaUsers,
    FaEye,
    FaGitter,
    FaTv,
    FaUserPlus,
    FaTasks,
    FaFileAlt,
    FaPlaneDeparture,
    FaHamsa,
    FaRegCalendarAlt,
    FaCalendarPlus
} from "react-icons/fa";

import {RightsWrapper} from "../../components/_utils/utils";
  
const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
];

const COLORS = ['#56BFEE', '#69ccf9'];

class OfficeManagerDashboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            visaStatusCount: {visaFillings: []},
            drawer: false,
            showAppointmentDrawar: false,
            drawerParam: {},
            appointments: {},
            totalStudentsOperationManager: {
                total: 0
            },
            totalStudentsCounsellings: {
                total: 0
            },
            totalStudentsRegistration: {
                total: 0
            },
            totalStudentsApplication: {
                total: 0
            },
            totalStudentsVisa: {
                total: 0
            },
            totalStudentsClaim: {
                total: 0
            },
            totalTodaysStudentsOperationManager: {
                total: 0,
                arr: []
            },
            totalTodaysStudentsCounsellings: {
                total: 0,
                arr: []
            },
            totalTodaysStudentsRegistration: {
                total: 0,
                arr: []
            },
            totalTodaysStudentsApplication: {
                total: 0,
                arr: []
            },
            totalTodaysStudentsVisa: {
                total: 0,
                arr: []
            },
            totalTodaysStudentsClaim: {
                total: 0,
                arr: []
            },
            tasks:{
                total: 0
            },
        }
    }

    async componentDidMount() {
        this.loadAllApis();
    }

    loadAllApis = async() => {
        let response = await Request.getOfficeManagerData({deleted: false});
        if(response) {
            this.setState({...response })
        }   

        let localUser = JSON.parse(localStorage.getItem('user'));
        let params = {user: localUser._id}
        
        Request.getTodayFollowupsData(params).then(({data: todayFollowupDataCount}) => {
            this.setState({todayFollowupDataCount})
        })
    }

    componentWillReceiveProps(props) {
        const {timer} = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const {dispatch} = this.props;

        const {
            drawer, 
            drawerParam,
            todayFollowupDataCount,
            totalStudentsOperationManager,
            totalStudentsCounsellings,
            totalStudentsRegistration,
            totalStudentsApplication,
            totalStudentsVisa,
            totalStudentsClaim,
            totalTodaysStudentsOperationManager,
            totalTodaysStudentsCounsellings,
            totalTodaysStudentsRegistration,
            totalTodaysStudentsApplication,
            totalTodaysStudentsVisa,
            totalTodaysStudentsClaim,
            appointments,
            showAppointmentDrawar,
            tasks
        } = this.state;

        return (
            <div className='dark-mode site-card-wrapper'>
                {
                    drawer && <ListDrawer
                        param={drawerParam}

                        onClose={() => {
                            this.setState({ drawer: false })
                        }} />
                }
                <RightsWrapper myRight={"officeManagerDesk.view"}>
                <Row>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaGitter /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Operation Manager's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsOperationManager.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-1'><a href="/desk/operation-manager-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaTv /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Counselling's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsCounsellings.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-2'><a href="/desk/all-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaUserPlus /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Registration's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsRegistration.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-3'><a href="/desk/allRegistration-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-4 elevation-1"><FaFileAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Application's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsApplication.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-4'><a href="/desk/allApplication-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-5 elevation-1"><FaPlaneDeparture /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Visa's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsVisa.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-5'><a href="/desk/allVisa-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={8} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-6 elevation-1"><FaHamsa /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Claim's Desk</span>
                                <span className="info-box-number">
                                    {totalStudentsClaim.total}
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-6'><a href="/desk/allClaim-desk" target='_blank'><FaEye /></a></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
                </RightsWrapper>
                <RightsWrapper myRight={"officeManagerCount.view"}>
                <Row>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaGitter /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Operation Manager</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Operation Manager`,
                                                arr: totalTodaysStudentsOperationManager.arr,
                                                count: totalTodaysStudentsOperationManager.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsOperationManager.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaTv /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Counselling</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Counselling`,
                                                arr: totalTodaysStudentsCounsellings.arr,
                                                count: totalTodaysStudentsCounsellings.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsCounsellings.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaUserPlus /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Registration</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Registration`,
                                                arr: totalTodaysStudentsRegistration.arr,
                                                count: totalTodaysStudentsRegistration.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsRegistration.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-4 elevation-1"><FaFileAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Application</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Application`,
                                                arr: totalTodaysStudentsApplication.arr,
                                                count: totalTodaysStudentsApplication.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsApplication.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-5 elevation-1"><FaPlaneDeparture /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Visa</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Visa`,
                                                arr: totalTodaysStudentsVisa.arr,
                                                count: totalTodaysStudentsVisa.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsVisa.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-6 elevation-1"><FaHamsa /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's On Claim</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            drawerParam: {
                                                title: `Today's On Claim`,
                                                arr: totalTodaysStudentsClaim.arr,
                                                count: totalTodaysStudentsClaim.total
                                            }
                                        })
                                    }}>{totalTodaysStudentsClaim.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-7 elevation-1"><FaTasks /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Tasks</span>
                                <span className="info-box-number">
                                    {tasks.total}
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-8 elevation-1"><FaRegCalendarAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Appointments</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            showAppointmentDrawar: true
                                        })
                                    }}>{appointments.total}</a>
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-8'>
                                            <a href='/appointment' target='_blank'><FaCalendarPlus /></a>
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    {
                        showAppointmentDrawar && appointments.total > 0 ? 
                            <Col span={24}>
                                <h2>{`Appointments : ${appointments.total}`}</h2>
                                <table cellPadding={10} className='student-custom-table'>
                                    <thead>
                                        <tr>
                                            <th>Appointment Id</th>
                                            <th>Subject</th>
                                            <th>Type</th>
                                            <th>Name</th>
                                            <th>Date/time</th>
                                            <th>Attendees</th>
                                            <th>Created By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            appointments.data.map((appointment, index) => {
                                                return(
                                                    <tr key={index}>
                                                        <td>{appointment.appId}</td>
                                                        <td>{appointment.subject}</td>
                                                        <td>{appointment.fromType}</td>
                                                        <td>{appointment.name}</td>
                                                        <td>
                                                            <div>{appointment && moment(appointment.startDate).format('DD-MMM-YYYY')}</div>
                                                            <div>{appointment && appointment.startTime}</div>
                                                        </td>
                                                        <td>
                                                            <div>{appointment && appointment.attendees && appointment.attendees.length && appointment.attendees.map((item) => {
                                                                return <span>{item} {`, ${'\n'}`}</span>
                                                            })}</div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <div className={common.user}>{appointment ? appointment.name : ''}</div>
                                                                <small>{appointment ? moment(appointment.time).format('lll') : ''}</small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        :null
                    }
                </Row>
                </RightsWrapper>
                <RightsWrapper myRight={"officeManagerTodayFollowup.view"}>
                <Row>
                    <Col span={24}>
                        <Card title={
                            <span>
                                <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                <span style={{paddingLeft: '10px'}}>Today Followups ({todayFollowupDataCount && todayFollowupDataCount.totalFollowupCount ? todayFollowupDataCount.totalFollowupCount : 0})</span>
                            </span>
                        }
                        headStyle={{
                            backgroundColor: '#6d6d6d',
                            color: 'white',
                            minHeight: '11px',
                            fontSize: '17px'
                        }}
                        bodyStyle={{padding: '34px'}} bordered={false}
                        style={{height: '145px', marginTop: '30px'}}>
                            <Row> 
                                <Col span={3}> 
                                    <Row>
                                        <Col span={3}>
                                            <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Active</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.activeCount != 0 ? 
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Active', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: '#8ac545'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.activeCount}
                                                        </div>
                                                    </a> 
                                                : <div className={styles.followupsNumber} style={{color: '#8ac545'}}> 0</div>
                                            }
                                        </Col>
                                    </Row> 
                                </Col>
                                <Col span={5}> 
                                    <Row>
                                        <Col span={3}> 
                                            <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.pickCallCount != 0 ? 
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.pickCallCount}
                                                        </div>
                                                    </a> 
                                                :
                                                    <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                            }
                                        </Col>
                                    </Row> 
                                </Col>
                                <Col span={5}> 
                                    <Row>
                                        <Col span={3}> 
                                            <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.busyCallCount != 0 ? 
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.busyCallCount}
                                                        </div>
                                                    </a> 
                                                :
                                                    <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                            }
                                        </Col>
                                    </Row> 
                                </Col>
                                <Col span={5}> 
                                    <Row>
                                        <Col span={3}> 
                                            <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Not Intrested</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.notInterestedCount != 0 ?
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.notInterestedCount}
                                                        </div>
                                                    </a> 
                                                : 
                                                    <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={4}> 
                                    <Row>
                                        <Col span={3}> 
                                            <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Out of Town</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.outOfTownCount != 0 ?
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.outOfTownCount}
                                                        </div>
                                                    </a> 
                                                : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={2}> 
                                    <Row>
                                        <Col span={3}> 
                                            <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                        </Col>
                                        <Col>
                                            <div className={styles.followupsVisa}>Cold</div>
                                            {
                                                todayFollowupDataCount && todayFollowupDataCount.coldCount != 0 ? 
                                                    <a onClick={() => {
                                                        dispatch(
                                                            getUrlPushWrapper('followUp.follow', {followUpType: 'Cold', followUpShow: 'Today'})
                                                        )
                                                    }}>
                                                        <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                            {todayFollowupDataCount && todayFollowupDataCount.coldCount}
                                                        </div>
                                                    </a> 
                                                : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                            }
                                        </Col>
                                    </Row> 
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                </RightsWrapper>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
(OfficeManagerDashboard)
